/**
 * TanStack Query provider cho bản SPA.
 *
 * Tách khỏi `providers.tsx` (bản Next gộp QueryClient + AuthProvider) vì hai
 * provider giờ nằm ở hai tầng khác nhau: QueryClient bọc ngoài router, còn
 * AuthProvider phải nằm trong router để dùng được `useNavigate()`.
 *
 * `providers.tsx` giữ nguyên, không đụng tới — bản Next vẫn đang chạy production
 * cho tới khi cutover.
 *
 * Tuỳ chọn `defaultOptions` sao y bản cũ, cố ý không "tranh thủ" chỉnh: đổi
 * `staleTime` hay `retry` giữa lúc migration sẽ làm mọi khác biệt về số lần gọi
 * API trở nên không quy được về đâu.
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

export function QueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30 * 1000,
            refetchOnWindowFocus: true,
            retry: 1,
          },
        },
      }),
  );

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
